import { INotice } from '@src/interfaces/notice';
import { noticeKeys } from '@src/keys/noticeKey';
import noticeApiList from '@src/services/notice';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import React from 'react';

const useNotice = () => {
  const fetchNotice = (): UseQueryResult<Array<INotice>, AxiosError> => {
    return useQuery(noticeKeys.noticeList, () => noticeApiList.getNoticeAll());
  };

  return {
    fetchNotice,
  };
};

export default useNotice;
